import {AxiosResponse} from 'axios';
//api
import {orgAPI} from '@/core/api';
//enum
import {API_URL} from '../enums/api-url.enum';
import {IRequestWithPagination} from '../types';
import {
	IGetUnpaidItemsResponse,
	IGetUnpaidTablesResponse,
	IGetParticipantsResponse,
	IGetMaxBidsResponse,
	IOrganizationFullReport,
	IOrganizationFullReportColumns,
	IFinancialReportRequestWithPagination,
	IFinancialReportResponceWithPagination,
	IFullRepostCSV,
	} from '../types/organization-reports.interface';

class OrganizationReportsService {
	static getUnpaidItems = async (reqBody: IRequestWithPagination): Promise<AxiosResponse<IGetUnpaidItemsResponse>> =>
		orgAPI.post(API_URL.REPORT_UNPAID_ITEMS, reqBody);

	static getUnpaidTables = async (reqBody: IRequestWithPagination): Promise<AxiosResponse<IGetUnpaidTablesResponse>> =>
		orgAPI.post(API_URL.REPORT_UNPAID_TABLES, reqBody);

	static getParticipants = async (reqBody: IRequestWithPagination): Promise<AxiosResponse<IGetParticipantsResponse>> =>
		orgAPI.post(API_URL.REPORT_PARTICIPANTS, reqBody);

	static getMaxBids = async (reqBody: IRequestWithPagination): Promise<AxiosResponse<IGetMaxBidsResponse>> =>
		orgAPI.post(API_URL.REPORT_MAX_BIDS, reqBody);

	static getUnpaidItemsCsv = async (eventId: number): Promise<AxiosResponse<File>> =>
		orgAPI.get(`${API_URL.REPORT_GET_FILE_UNPAID_ITEMS}/${eventId}`);

	static getUnpaidTablesCsv = async (eventId: number): Promise<AxiosResponse<File>> =>
		orgAPI.get(`${API_URL.REPORT_GET_FILE_UNPAID_TABLES}/${eventId}`);

	static getParticipantsCsv = async (eventId: number): Promise<AxiosResponse<File>> =>
		orgAPI.get(`${API_URL.REPORT_GET_FILE_PARTICIPANTS}/${eventId}`);

	static getMaxBidsCsv = async (eventId: number): Promise<AxiosResponse<File>> =>
		orgAPI.get(`${API_URL.REPORT_GET_FILE_MAX_BIDS}/${eventId}`);

	static getFullReport = async (reqBody: {eventId: number}): Promise<AxiosResponse<IOrganizationFullReport>> =>
		orgAPI.post(API_URL.REPORT_GET_FULL_REPORT, reqBody);

	static getReportColumns = async (): Promise<AxiosResponse<IOrganizationFullReportColumns[]>> =>
		orgAPI.get(API_URL.REPORT_GET_FULL_REPORT_COLUMNS);

	static getAttendeeFinancialReport = async (reqBody: IFinancialReportRequestWithPagination): Promise<AxiosResponse<IFinancialReportResponceWithPagination>> =>
		orgAPI.post(API_URL.REPORT_GET_ATTENDEE_FINANCIAL_REPORT, reqBody);

	static getFullReportCsv = async (reqBody: IFullRepostCSV): Promise<AxiosResponse<File>> =>
		orgAPI.post(`${API_URL.REPORT_GET_FILE_ATTENDEE_FINANCIAL_REPORT}`, reqBody);
}

export {OrganizationReportsService};

